const DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

function parseYmd(value) {
    const match = String(value || '').match(DATE_PATTERN);
    if (!match) return null;

    const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    if (
        date.getFullYear() !== Number(match[1])
        || date.getMonth() !== Number(match[2]) - 1
        || date.getDate() !== Number(match[3])
    ) {
        return null;
    }

    date.setHours(0, 0, 0, 0);
    return date;
}

export function formatNearbyDateRange(checkIn, checkOut) {
    const start = parseYmd(checkIn);
    const end = parseYmd(checkOut);
    if (!start || !end) return '';

    const startMonth = start.toLocaleString('en-US', { month: 'short' }).toUpperCase();
    const endMonth = end.toLocaleString('en-US', { month: 'short' }).toUpperCase();
    const startDay = start.getDate();
    const endDay = end.getDate();
    const startYear = start.getFullYear();
    const endYear = end.getFullYear();

    if (startYear === endYear && start.getMonth() === end.getMonth()) {
        return `${startMonth} ${startDay} – ${endMonth} ${endDay}, ${endYear}`;
    }

    if (startYear === endYear) {
        return `${startMonth} ${startDay} – ${endMonth} ${endDay}, ${endYear}`;
    }

    return `${startMonth} ${startDay}, ${startYear} – ${endMonth} ${endDay}, ${endYear}`;
}
